import { useMutation } from '@tanstack/react-query';
import { getOnboardingSpecialistUrl } from '../../services/business';

function useMeetWithSpecialist() {
  return useMutation({
    mutationFn: async (
      payload: Parameters<typeof getOnboardingSpecialistUrl>[0],
    ) => getOnboardingSpecialistUrl(payload),
  });
}

export default useMeetWithSpecialist;
